import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';

import DropdownCountry from '@commons/dropdownCountry';
import WhiteCard from '@commons/WhiteCard';

import ClientTextInput from '../ClientTextInput';

import {
  BlockTitle,
  BlockTitleIcon,
  Divider,
  FieldLabel,
  FieldsGrid,
  LabeledField,
} from '../clientFormStyledComponents';

/**
 * "Entreprise" block shared by the external-client creation and detail pages. No field is required.
 * `isReadOnly` renders every field disabled for the consultation mode of the detail page.
 */
const ClientCompanyCard = (props) => {
  const {
    address,
    onChangeAddress,
    postCode,
    onChangePostCode,
    city,
    onChangeCity,
    country,
    onChangeCountry,
    legalName,
    onChangeLegalName,
    siret,
    onChangeSiret,
    vatNumber,
    onChangeVatNumber,
    isReadOnly,
    width,
    maxWidth,
  } = props;

  const renderContent = () => (
    <>
      <FieldsGrid>
        <ClientTextInput
          isReadOnly={isReadOnly}
          label={i18next.t('EXTERNAL_CLIENTS.CREATION.ADDRESS')}
          value={address}
          onChange={onChangeAddress}
        />
        <ClientTextInput
          isReadOnly={isReadOnly}
          label={i18next.t('EXTERNAL_CLIENTS.CREATION.POST_CODE')}
          value={postCode}
          onChange={onChangePostCode}
        />
        <ClientTextInput
          isReadOnly={isReadOnly}
          label={i18next.t('GENERAL.CITY')}
          value={city}
          onChange={onChangeCity}
        />
        <LabeledField>
          <FieldLabel>{`${i18next.t('GENERAL.COUNTRY')} :`}</FieldLabel>
          <DropdownCountry
            handleSelect={(countryCode) => onChangeCountry(countryCode)}
            isDisabled={isReadOnly}
            selected={country}
            fullWidth
          />
        </LabeledField>
      </FieldsGrid>
      <Divider />
      <FieldsGrid>
        <ClientTextInput
          isReadOnly={isReadOnly}
          label={i18next.t('EXTERNAL_CLIENTS.CREATION.LEGAL_NAME')}
          value={legalName}
          onChange={onChangeLegalName}
        />
        <ClientTextInput
          isReadOnly={isReadOnly}
          label={i18next.t('EXTERNAL_CLIENTS.CREATION.SIRET')}
          value={siret}
          onChange={onChangeSiret}
        />
        <ClientTextInput
          isReadOnly={isReadOnly}
          label={i18next.t('EXTERNAL_CLIENTS.CREATION.VAT_NUMBER')}
          value={vatNumber}
          onChange={onChangeVatNumber}
        />
      </FieldsGrid>
    </>
  );

  return (
    <WhiteCard
      maxWidth={maxWidth}
      renderContent={renderContent()}
      title={
        <BlockTitle>
          <BlockTitleIcon src={'/images/shopping-bag.svg'} />
          {i18next.t('EXTERNAL_CLIENTS.CREATION.COMPANY')}
        </BlockTitle>
      }
      width={width}
    />
  );
};

ClientCompanyCard.propTypes = {
  address: PropTypes.string,
  onChangeAddress: PropTypes.func.isRequired,
  postCode: PropTypes.string,
  onChangePostCode: PropTypes.func.isRequired,
  city: PropTypes.string,
  onChangeCity: PropTypes.func.isRequired,
  country: PropTypes.string,
  onChangeCountry: PropTypes.func.isRequired,
  legalName: PropTypes.string,
  onChangeLegalName: PropTypes.func.isRequired,
  siret: PropTypes.string,
  onChangeSiret: PropTypes.func.isRequired,
  vatNumber: PropTypes.string,
  onChangeVatNumber: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
};

ClientCompanyCard.defaultProps = {
  address: '',
  postCode: '',
  city: '',
  country: '',
  legalName: '',
  siret: '',
  vatNumber: '',
  isReadOnly: false,
  width: '840px',
};

export default ClientCompanyCard;
